import { AsyncLoaderProps } from 'components/AsyncLoader';
import { DEFAULT_ERROR_MESSAGE } from 'config';
import dictionary from 'utils/dictionary';
import { AxiosCustomError } from './axios-custom-error.model';
import { CustomError } from './custom-error.model';

export function mapErrorsToAsyncLoader(
  error: unknown
): Pick<
  AsyncLoaderProps,
  | 'error'
  | 'errorTitle'
  | 'errorMessage'
  | 'errorDetail'
  | 'onClickRetryButton'
  | 'severity'
> | null {
  if (!error || typeof error !== 'object') {
    return null;
  }

  // AxiosCustomError Error - comes from axios interceptor
  if (error?.hasOwnProperty('customError')) {
    const { customError } = error as AxiosCustomError;
    if (customError.type === 'TECHNICAL' && customError.transactionId) {
      return {
        error: true,
        errorMessage: `${customError.description} ID: ${customError.transactionId}`,
      };
    }

    if (customError.type === 'BUSINESS') {
      return {
        error: true,
        errorTitle:
          customError.severity === 'WARNING'
            ? dictionary.mapErrorsToAsyncLoader_scheduledChange_errorTitle
            : dictionary.attention_with_exclamation_mark,
        errorMessage: `${customError.description}`,
        onClickRetryButton: undefined,
        severity: customError.severity,
      };
    }

    return {
      error: true,
      errorMessage: customError.description,
    };
  }

  // CustomError Error
  if (error?.hasOwnProperty('severity')) {
    const errorObject = error as CustomError;
    if (
      (errorObject.type === 'TECHNICAL' || errorObject.type === 'BUSINESS') &&
      errorObject.transactionId
    ) {
      return {
        error: true,
        errorMessage: `${errorObject.description} ID: ${errorObject.transactionId}`,
      };
    }
    return {
      error: true,
      errorMessage: errorObject.description,
    };
  }

  return {
    error: true,
    errorMessage: DEFAULT_ERROR_MESSAGE,
  };
}
